var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "#2C67F1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.44238 0.943115C1.71843 0.943115 1.94223 1.1671 1.94238 1.44312V4.49976H8.6123C8.8392 3.51318 9.71996 2.77722 10.7754 2.7771C12.0029 2.7771 12.998 3.77222 12.998 4.99976C12.9978 6.2271 12.0028 7.22241 10.7754 7.22241C9.72026 7.22229 8.83951 6.48592 8.6123 5.49976H1.94238V8.99976C1.94238 9.70558 2.5149 10.278 3.2207 10.2781H8.6123C8.83946 9.29185 9.72021 8.55554 10.7754 8.55542C12.0028 8.55542 12.9979 9.55068 12.998 10.7781C12.998 12.0056 12.0029 13.0007 10.7754 13.0007C9.72001 13.0006 8.83925 12.2646 8.6123 11.2781H3.2207C1.96261 11.278 0.942383 10.2579 0.942383 8.99976V1.44312C0.942535 1.16716 1.16642 0.943215 1.44238 0.943115ZM10.7754 9.55542C10.1004 9.55556 9.5529 10.103 9.55273 10.7781C9.55273 11.4532 10.1003 12.0006 10.7754 12.0007C11.4506 12.0007 11.998 11.4533 11.998 10.7781C11.9979 10.103 11.4505 9.55542 10.7754 9.55542ZM10.7754 3.7771C10.1003 3.77724 9.55273 4.32459 9.55273 4.99976C9.55297 5.67473 10.1004 6.22227 10.7754 6.22241C11.4505 6.22241 11.9978 5.67481 11.998 4.99976C11.998 4.3245 11.4506 3.7771 10.7754 3.7771Z",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrace);
export default __webpack_public_path__ + "static/media/trace.e48e2c4b105827180a11608bac1ac7d9.svg";
export { ForwardRef as ReactComponent };